'use es6';

import tinymce from 'tinymce';
import TinyMcePopover from './TinyMcePopover';
import AutoCompleteOptions from './AutocompleteOptions';
import { useAutoCompleteIsActive, useFilteredAutocompleteCommands, resetAutocompleteAtomState, useActiveAutocompleteTrigger } from '../data/autocompleteAtoms';
import { openAutocompleteInlineDropdownMenu, removeAutocompleteSpanTarget } from '../hsautocomplete/utils';
import { useCallback, useEffect, useRef } from 'react';
import { NoAuthGatesProvider } from 'ai-components-ui-library/hooks/useIsUngated';
import { jsx as _jsx } from "react/jsx-runtime";
const mapTriggerToArrowColor = {
  '/': 'fill-tertiary-hover',
  '#': undefined
};
export default function AutoCompletePopover({
  targetNode,
  editor
}) {
  var _editor$settings$gate;
  const isShowing = useAutoCompleteIsActive();
  const activeAutocompleteTrigger = useActiveAutocompleteTrigger();
  const commands = useFilteredAutocompleteCommands();
  const gates = (_editor$settings$gate = editor.settings.gates) !== null && _editor$settings$gate !== void 0 ? _editor$settings$gate : [];
  const arrowColor = mapTriggerToArrowColor[activeAutocompleteTrigger];
  const handleRemove = useCallback(() => {
    resetAutocompleteAtomState();
    removeAutocompleteSpanTarget(editor);
  }, [editor]);
  const isOpen = isShowing && Boolean(commands) && editor.id === tinymce.activeEditor.id;
  const hasRenderedRef = useRef(false);
  useEffect(() => {
    if (!hasRenderedRef.current) {
      hasRenderedRef.current = true;
      return;
    }
    if (isOpen) {
      editor.fire('hsautocomplete:openPopover');
    } else {
      editor.fire('hsautocomplete:closePopover');
    }
  }, [editor, isOpen]);
  useEffect(() => {
    const handleOpenEvent = ({
      filteredCommands
    } = {}) => {
      openAutocompleteInlineDropdownMenu(editor, filteredCommands, editor.selection.getRng());
    };
    editor.on('hscontentgeneration:openSlashPopover', handleOpenEvent);
    return () => {
      editor.off('hscontentgeneration:openSlashPopover', handleOpenEvent);
    };
  }, [editor]);
  return /*#__PURE__*/_jsx(TinyMcePopover, {
    placement: "bottom right",
    editor: editor,
    open: isOpen,
    animateOnToggle: false,
    onRemove: handleRemove,
    arrowColor: arrowColor,
    target: targetNode,
    content: /*#__PURE__*/_jsx(NoAuthGatesProvider, {
      gates: gates,
      children: /*#__PURE__*/_jsx(AutoCompleteOptions, {
        commands: commands
      })
    })
  });
}